// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"37607baf","380":"6878bae3","385":"122e378a","640":"e277f033","672":"56c62949","783":"3e30f728","796":"1fd95601","836":"d354f167","875":"37607baf","893":"f76b7ab9","931":"e70776c0","953":"e70776c0"}[chunkId] + ".chunk.css";
};